module.exports = __webpack_public_path__ + "static/media/cat.a5d68a5f.svg";